import { useState } from 'react';
import { Alert } from '@material-ui/lab';
import { Box, Grid, TextField, Typography } from '@material-ui/core';
import { useAuthFunctions } from 'contexts/AuthContext';
import { useHistory } from 'react-router-dom';
import DefaultButton from 'components/DefaultButton';
import MaiaLogo from 'components/MaiaLogo';
import MaiaText from 'components/MaiaText';
import RegisterLayout from 'pages/RegisterLayout';
import sideImage from '_assets/login/side-image.svg';
import useStyles from './styles';

const PasswordReset = () => {
  const classes = useStyles();
  const history = useHistory();

  const [email, setEmail] = useState('');
  const [emailHasBeenSent, setEmailHasBeenSent] = useState(false);
  const [error, setError] = useState(null);

  const { sendResetPasswordEmail } = useAuthFunctions();

  const onChangeHandler = event => {
    const { value } = event.currentTarget;

    setEmail(value);
  };

  const sendResetEmail = event => {
    event.preventDefault();
    setError(null);
    setEmailHasBeenSent(false);

    const redirectURL = window.location.href.split('/password-reset')[0] + '/login';
    sendResetPasswordEmail(email, redirectURL)
      .then(() => {
        setEmailHasBeenSent(true);
      })
      .catch(error => {
        if (error.code === 'auth/user-not-found') {
          setError("Aucun compte ne correspond à cette adresse email");
        } else {
          setError('Erreur durant la réinitialisation du mot de passe');
        }
      });
  };

  const SideComponent = () => (
    <Grid container direction='column' style={{ height: 'auto' }}>
      <Grid container item justifyContent='center'>
        <MaiaLogo />
      </Grid>

      <Grid container item alignItems='center' justifyContent='center'>
        <img src={sideImage} alt='Computer' width={300} />
      </Grid>

      <Grid container direction='column' justifyContent='center' style={{ flexGrow: 1 }}>
        <Box style={{ margin: '0 10%' }}>
          <Typography align='center' variant='h3'>
            <MaiaText />,
          </Typography>
          <Typography variant='h3' align='center'>
            la plateforme gratuite pour les <br /> TPE-PME du secteur du <br /> tourisme.
          </Typography>
        </Box>

        <Box style={{ marginTop: '5%', marginRight: '5%', marginLeft: '5%' }}>
          <Typography variant='h3' align='center'>
            Gérez facilement votre activité et
            <br /> mettez la en ligne grâce à <MaiaText />
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );

  return (
    <RegisterLayout SideComponent={<SideComponent />}>
      <Grid container alignItems='center' justifyContent='center'>
        <Grid container item sm={12} md={6} spacing={3} style={{ height: '50%' }}>
          <Grid container item xs={12} alignItems='center' justifyContent='center' style={{ height: '25%' }}>
            <Typography className={classes.title} variant='h2'>Mot de passe oublié</Typography>
          </Grid>

          <Grid container item xs={12} justifyContent='center'>
            <form style={{ width: '100%' }} onSubmit={sendResetEmail}>
              <Grid container spacing={2}>
                <Grid container item xs={12}>
                  <TextField
                    fullWidth
                    label='Adresse email'
                    name='userEmail'
                    variant='outlined'
                    value={email}
                    onChange={onChangeHandler}
                  />
                </Grid>

                {emailHasBeenSent &&
                  <Grid container item xs={12} alignItems='center' justifyContent='center'>
                    <Alert className={classes.alert} severity='success'>
                      Un email vient de vous être envoyé !
                    </Alert>
                  </Grid>
                }
                {error &&
                  <Grid container item xs={12} alignItems='center' justifyContent='center'>
                    <Alert className={classes.alert} severity='error'>
                      {error}
                    </Alert>
                  </Grid>
                }

                <Grid container item xs={12} alignItems='center' justifyContent='center'>
                  <DefaultButton cancel onClick={() => history.goBack()}>
                    Annuler
                  </DefaultButton>
                  <DefaultButton color='secondary' type='submit' variant='contained'>
                    Valider
                  </DefaultButton>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </RegisterLayout>
  );
};

export default PasswordReset;
